/* Swish theme global JS */
(function () {
  // Rotating announcement bar
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 3800);
  });

  // Scroll-in animation
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-inview'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.fade-up').forEach(function (el) { io.observe(el); });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var src = btn.getAttribute('data-src');
        if (main && src) { main.src = src; }
      });
    });
  });

  // Variant swatches + bundle quantity selection
  document.querySelectorAll('[data-product-form]').forEach(function (wrapper) {
    var form = wrapper.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');

    wrapper.querySelectorAll('.swatch').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        wrapper.querySelectorAll('.swatch').forEach(function (l) { l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        if (idInput && input.value) idInput.value = input.value;
      });
    });

    wrapper.querySelectorAll('.bundle-option').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        wrapper.querySelectorAll('.bundle-option').forEach(function (l) { l.classList.remove('is-selected'); });
        label.classList.add('is-selected');
        if (qtyInput && input.value) qtyInput.value = input.value;
      });
    });
  });

  // Before/after slider
  document.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
    var beforeWrap = slider.querySelector('[data-ba-before]');
    var handle = slider.querySelector('[data-ba-handle]');
    var range = slider.querySelector('[data-ba-range]');
    var frame = slider.querySelector('.ba-slider__frame');
    if (!beforeWrap || !range || !frame) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      beforeWrap.style.width = pct + '%';
      if (handle) handle.style.left = pct + '%';
      range.value = pct;
    }
    range.addEventListener('input', function () { setPos(parseFloat(range.value)); });

    function fromEvent(e) {
      var rect = frame.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      setPos((x / rect.width) * 100);
    }
    var dragging = false;
    frame.addEventListener('pointerdown', function (e) { dragging = true; fromEvent(e); });
    window.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    window.addEventListener('pointerup', function () { dragging = false; });
    setPos(50);
  });

  // Feature hotspots
  document.querySelectorAll('[data-hotspot]').forEach(function (pin) {
    pin.addEventListener('click', function () {
      var idx = pin.getAttribute('data-hotspot');
      document.querySelectorAll('[data-hotspot-item]').forEach(function (item) {
        var active = item.getAttribute('data-hotspot-item') === idx;
        item.classList.toggle('is-active', active);
        if (active) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  });

  // Sticky ATC visibility
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('[data-main-atc]');
  if (stickyBar && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { threshold: 0 }).observe(mainBtn);
  }
})();
